import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { isEmpty, isNil } from "lodash";
import { Table, DatePicker, Input, Button, Modal, Form, Select } from "antd";
import { SearchOutlined, PrinterTwoTone } from "@ant-design/icons";
import {
  actionForOldEmailPaginaton,
  actionForGetOldEmailDetail,
  resetOldMailDetail,
} from "services/redux/oldEmail/action";
import { LogoImage } from "utils/imageConstants";
import MailViewer from "./MailViewer";

export default function MailViewOnly() {
  const {
    oldMailData,
    oldMailDataTotalCount,
    oldMailDataTotalRecord,
    oldMailDataLoading,
    oldMailDetail,
    oldMailDetailLoading,
  } = useSelector((state) => state.OldEmailServiceReducer);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState(
    () => localStorage.getItem("searchKeyword") || ""
  );
  const [referenceText, setReferenceText] = useState(
    () => localStorage.getItem("referenceText") || ""
  );
  const [companyName, setCompanyName] = useState(
    () => localStorage.getItem("companyName") || ""
  );
  const [emailAddress, setEmailAddress] = useState(
    () => localStorage.getItem("emailAddress") || ""
  );
  const [emailSubject, setEmailSubject] = useState(
    () => localStorage.getItem("emailSubject") || ""
  );
  const [searchDateFrom, setSearchDateFrom] = useState(null);
  const [searchDateTo, setSearchDateTo] = useState(null);
  const [sortType, setSortType] = useState("asc");
  const [sorting, setSorting] = useState("date");
  const [skipCount, setSkipCount] = useState(0);
  const [token, setToken] = useState({
    accessToken: "8A80B51E-168E-7B42-8A05-7D2C1B5551D9",
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
  });

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const printRef = useRef();
  const { RangePicker } = DatePicker;

  const MAX_PAGINATION = 200;

  const fetchData = (
    MaxResultCount = pagination?.pageSize,
    SkipCount = skipCount,
    referenceText = "",
    companyName = "",
    emailAddress = "",
    searchDateFrom = "",
    searchDateTo = "",
    searchKeyword = "",
    sortType = "",
    emailSubject = ""
  ) => {
    const payload = {
      MaxResultCount,
      SkipCount,
      referenceText,
      companyName,
      emailAddress,
      emailSubject,
      searchDateFrom: searchDateFrom ? searchDateFrom.toISOString() : null,
      searchDateTo: searchDateTo ? searchDateTo.toISOString() : null,
      searchKeyword,
      sortType,
    };

    console.log("Sending POST request with payload:", payload);

    dispatch(actionForOldEmailPaginaton(payload, token));
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetOldMailDetail());
    };
  }, []);

  const columns = [
    {
      title: "S.N",
      render: (text, object, index) => index + 1,
      width: 40,
    },
    {
      title: "Subject",
      dataIndex: "mailSubject",
      render: (text, record) => (
        <span
          style={{ cursor: "pointer", color: "#1890ff" }}
          onClick={(e) => {
            e.stopPropagation();
            setEmailSubject(text);
            setIsModalVisible(true);
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Party",
      dataIndex: "mailPartyTxt",
    },
    {
      title: "Contact",
      dataIndex: "mailContactTxt",
    },
    {
      title: "From",
      dataIndex: "mailSenderAddress",
    },
    {
      title: "To",
      dataIndex: "mailTo",
    },
    {
      title: "Reference",
      dataIndex: "mailReference",
    },
    {
      title: "Date",
      dataIndex: "mailDate",
      render: (record) => {
        return record ? moment(record).format("YYYY-MM-DD, h:mm:ss a") : "----";
      },
    },
    {
      title: "ID",
      dataIndex: "id",
    },
  ];

  const handleSearch = () => {
    localStorage.setItem("searchKeyword", searchKeyword);
    localStorage.setItem("referenceText", referenceText);
    localStorage.setItem("companyName", companyName);
    localStorage.setItem("emailAddress", emailAddress);
    localStorage.setItem("emailSubject", emailSubject);

    fetchData(
      pagination?.pageSize,
      0,
      referenceText,
      companyName,
      emailAddress,
      searchDateFrom,
      searchDateTo,
      searchKeyword,
      sortType,
      emailSubject
    );
    setIsModalVisible(false);
  };

  const handlePaginationChange = (page, pageSize) => {
    setPagination({
      current: page,
      pageSize: pageSize,
    });
    setSkipCount((page - 1) * pageSize);
    const skipME = (page - 1) * pageSize;
    fetchData(
      pageSize,
      skipME,
      referenceText,
      companyName,
      emailAddress,
      searchDateFrom,
      searchDateTo,
      searchKeyword,
      sortType,
      emailSubject
    );
  };

  const clearSearchForm = () => {
    setSearchKeyword("");
    setReferenceText("");
    setCompanyName("");
    setEmailAddress("");
    setEmailSubject("");
    setSearchDateFrom(null);
    setSearchDateTo(null);
    setSortType("asc");
    setSorting("date");

    localStorage.removeItem("searchKeyword");
    localStorage.removeItem("referenceText");
    localStorage.removeItem("companyName");
    localStorage.removeItem("emailAddress");
    localStorage.removeItem("emailSubject");
  };

  return (
    <>
      <span
        style={{
          padding: "0 2em",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Old Email Search:
        <div>
          <Button
            type="text"
            icon={<SearchOutlined />}
            onClick={() => {
              setIsModalVisible(true);
            }}
            style={{ marginRight: "8px" }}
          />
        </div>
      </span>

      <section
        style={{
          height: "400px",
          border: "1px solid #FFFFFF",
        }}
      >
        <span
          style={{
            padding: "24px",
          }}
        >
          Total Records: {oldMailDataTotalRecord}
        </span>
        <Table
          rowKey="id"
          style={{
            padding: "24px",
            height: "200px",
            marginBottom: "2em",
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                const param = {
                  accessToken: "8A80B51E-168E-7B42-8A05-7D2C1B5551D9",
                  dMailId: record?.id,
                };
                dispatch(actionForGetOldEmailDetail(record?.id, param));
              },
            };
          }}
          loading={{
            indicator: <img src={LogoImage} height="auto" width="50px" />,
            spinning: oldMailDataLoading,
          }}
          columns={columns}
          dataSource={oldMailData?.items}
          scroll={{ y: 55 * 5 }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: oldMailDataTotalRecord,
            showSizeChanger: false,
            onChange: handlePaginationChange,
          }}
        />
      </section>

      {!isEmpty(oldMailDetail) && <MailViewer body={oldMailDetail} />}

      <Modal
        title="Search Email Body"
        visible={isModalVisible}
        onOk={handleSearch}
        onCancel={() => setIsModalVisible(false)}
        okText="Apply Search"
        cancelText="Cancel"
        footer={[
          <Button key="clear" onClick={clearSearchForm}>
            Clear Search
          </Button>,
          <Button key="back" onClick={() => setIsModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleSearch}>
            Apply Search
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="Search Keyword">
            <Input
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              placeholder="Enter search keyword"
            />
          </Form.Item>

          <Form.Item label="Search Date Range">
            <RangePicker
              value={[searchDateFrom, searchDateTo]}
              onChange={(dates) => {
                setSearchDateFrom(dates ? dates[0] : null);
                setSearchDateTo(dates ? dates[1] : null);
              }}
              format="YYYY-MM-DD"
            />
          </Form.Item>

          <Form.Item label="Sort Type">
            <Select value={sortType} onChange={(value) => setSortType(value)}>
              <Option value="asc">Ascending</Option>
              <Option value="desc">Descending</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Sorting Field">
            <Select value={sorting} onChange={(value) => setSorting(value)}>
              <Option value="date">Date</Option>
              <Option value="subject">Subject</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Reference Text">
            <Input
              value={referenceText}
              onChange={(e) => setReferenceText(e.target.value)}
              placeholder="Enter search keyword"
            />
          </Form.Item>

          <Form.Item label="Company Name">
            <Input
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Enter Company Name"
            />
          </Form.Item>

          <Form.Item label="Email Address">
            <Input
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              placeholder="Enter Email Address"
            />
          </Form.Item>

          <Form.Item label="Email Subject">
            <Input
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
              placeholder="Enter Email Subject"
              autoFocus={true}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
